// extracted by mini-css-extract-plugin
module.exports = {"body":"OptionsModal_body__2uW16","control":"OptionsModal_control__P9mZI","controlLabel":"OptionsModal_controlLabel__2leq2"};